import { render, staticRenderFns } from "./TheFrontOfficeBaseApp.vue?vue&type=template&id=1a2f77a2&scoped=true"
import script from "./TheFrontOfficeBaseApp.vue?vue&type=script&lang=js"
export * from "./TheFrontOfficeBaseApp.vue?vue&type=script&lang=js"
import style0 from "./TheFrontOfficeBaseApp.vue?vue&type=style&index=0&id=1a2f77a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2f77a2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
installComponents(component, {VApp})
